import { render, staticRenderFns } from "./CellRendererMISSuggestionsActions.vue?vue&type=template&id=fb108956"
import script from "./CellRendererMISSuggestionsActions.vue?vue&type=script&lang=js"
export * from "./CellRendererMISSuggestionsActions.vue?vue&type=script&lang=js"
import style0 from "./CellRendererMISSuggestionsActions.vue?vue&type=style&index=0&id=fb108956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports